<p>delete-bot-response works!</p>
